import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { FormControl, FormGroup, Validators, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { IHousehold } from 'app/models/household/household';
import { HouseholdService } from 'app/services/household-service';
import { AuthService } from '@shared/auth/auth.service';
import { formatDate } from '@angular/common';

/*
 * Edit Household
 */
@Component({
  selector: 'household-edit',
  templateUrl: 'household-edit.html',
  styleUrls: ['./household-edit.scss']
})
export class HouseholdEditComponent implements OnInit, AfterViewInit {
  @Input('householdId')
  householdId: number = 0;
  address: string = "";
  buttonText = "Add Household";
  loading: boolean = false;
  processing: boolean = false;
  household: IHousehold = {
    id: 0,
    householdHousingUnitKey: 0,
    householdHousingUnitStartDate: '',
    householdHousingUnitEndDate: '',
    createDate: '',
    createdby: '',
    lastUpdatedBy: '',
    lastUpdated: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    contactCellPhone: '',
    addressUnitNumber: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    county: '',
    latitude: 0,
    longitude: 0,
    personsInHousehold: 0,
    numberOfHouseholds: '',
    pregnancyInHousehold: false,
    comments: '',
    waterTreamentProvided: false,
    bottledWaterProvided: false,
    infantsUnder1: 0,
    age1to4: 0,
    age5to9: 0,
    age10to14: 0,
    age15to19: 0,
    age20to29: 0,
    age30to39: 0,
    age40to49: 0,
    age50to59: 0,
    age60to69: 0,
    age70to79: 0,
    age80Plus: 0,
    modifiedBy: '',
    age15AndBelow: 0,
    age16AndAbove: 0,
    infantsInHousehold: false,
    interactions: [],
    letters: [],
    treatments: [],
    preferredContactMethod: '',
    mailingAddress: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    infantsUnder2: 0,
    translationNeeded: false,
    language: '',
    requestedConfidentiality: false,
    learnedOfTesting: '',
    householdRelyOnWell: '',
    countyTestedWell: false,
    sharedWell: false,
    nitrateStripResult: '',
    importedPreferredContact: false,
    importedPreferredContactComments: '',
    eligible: false,
    declinedLubgwmaTestingServices: false,
    declinedLubgwmaTreatmentServices: false,
    renter: false,
    owner: false,
    residenceOther: '',
    residence: '',
    dateOfDecline: '',
    typeOfDecline: '',
    dateOfFurtherOutreach: '',
    treatmentDateOfDecline: '',
    treatmentTypeOfDecline: '',
    treatmentDateOfFurtherOutreach: ''
  };
  householdForm = new FormGroup({
    id: new FormControl(0),
    contactName: new FormControl('', Validators.required),
    contactEmail: new FormControl(''),
    contactPhone: new FormControl(''),
    contactCellPhone: new FormControl(''),
    preferredContactMethod: new FormControl(''),
    addressUnitNumber: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    zip: new FormControl(''),
    mailingAddress: new FormControl(''),
    mailingCity: new FormControl(''),
    mailingState: new FormControl(''),
    mailingZip: new FormControl(''),
    county: new FormControl(''),
    latitude: new FormControl(0),
    longitude: new FormControl(0),
    personsInHousehold: new FormControl(0),
    pregnancyInHousehold: new FormControl(false),
    comments: new FormControl(''),
    waterTreamentProvided: new FormControl(false),
    bottledWaterProvided: new FormControl(false),
    infantsUnder1: new FormControl(0),
    infantsUnder2: new FormControl(0),
    age1to4: new FormControl(0),
    age5to9: new FormControl(0),
    age10to14: new FormControl(0),
    age15to19: new FormControl(0),
    age20to29: new FormControl(0),
    age30to39: new FormControl(0),
    age40to49: new FormControl(0),
    age50to59: new FormControl(0),
    age60to69: new FormControl(0),
    age70to79: new FormControl(0),
    age80Plus: new FormControl(0),
    age15AndBelow: new FormControl(0),
    age16AndAbove: new FormControl(0),
    infantsInHousehold: new FormControl(false),
    translationNeeded: new FormControl(false),
    language: new FormControl(''),
    requestedConfidentiality: new FormControl(false),
    learnedOfTesting: new FormControl(''),
    householdRelyOnWell: new FormControl(''),
    countyTestedWell: new FormControl(false),
    sharedWell: new FormControl(false),
    nitrateStripResult: new FormControl(''),
    importedPreferredContact: new FormControl(false),
    importedPreferredContactComments: new FormControl(''),
    eligible: new FormControl(false),
    declinedLubgwmaTestingServices: new FormControl(false),
    declinedLubgwmaTreatmentServices: new FormControl(false),
    residence: new FormControl(''),
    residenceOther: new FormControl(''),
    dateOfDecline: new FormControl(''),
    typeOfDecline: new FormControl(''),
    dateOfFurtherOutreach: new FormControl(''),
    treatmentDateOfDecline: new FormControl(''),
    treatmentTypeOfDecline: new FormControl(''),
    treatmentDateOfFurtherOutreach: new FormControl(''),
  });

  constructor(public oregonWellDataService: OregonWellDataService,
    public householdService: HouseholdService,
    private toastr: ToastrService, private route: ActivatedRoute,
    private sharedService: SharedService, private router: Router, public authService: AuthService) {

    this.loading = true;
    let routeId = this.route.snapshot.paramMap.get("id");

    if (routeId != null && routeId != undefined && routeId.length > 0) {
      this.householdId = Number(this.route.snapshot.paramMap.get("id"));
    }
    if (this.householdId == null || this.householdId < 0) {
      this.householdId = 0;
    }
  }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.loadHousehold();
  }

  loadHousehold() {
    if (this.householdId <= 0) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.buttonText = "Update Household";

    this.householdService.getHouseholdById(this.householdId).subscribe(
      result => {
        this.household = result;
        this.setFormValues();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  delete() {
    this.sharedService.openConfirm("Are you sure you want to delete this household?\n\n This action will remove all letters, interactions and associations to housing units.\n");

    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        // delete
        this.householdService.deleteHousehold(this.householdId).subscribe(
          result => {
            this.toastr.success("Household Deleted!");
            //route back to search
            this.router.navigate(['households/search']);
          },
          error => {
            this.toastr.error("Unable to delete Household.");
            this.processing = false;
          }
        );

      }
    });
  }

  onSubmit() {
    // #region validation
    if (!this.householdForm.valid) {
      this.toastr.error("Please fix form validation issues");
      return;
    }

    if (this.householdForm.value.contactName == '') {
      this.toastr.error("Contact Name is required");
      return;
    }

    if (this.householdForm.value.contactPhone == '' && this.householdForm.value.contactEmail == '') {
      this.toastr.error("Contact Phone or Email is required");
      return;
    }

    // #endregion

    this.processing = true;
    this.getFormValues();
    if (this.household.id > 0) {

      // save
      this.householdService.saveHousehold(this.household).subscribe(
        result => {
          this.householdId = result;
          this.loadHousehold();
          this.toastr.success("Household updated");
          this.processing = false;
        },
        error => {
          this.processing = false;
        }
      );
    }
    else {

      // add
      this.householdService.saveHousehold(this.household).subscribe(
        result => {
          this.householdId = result;
          this.toastr.success("Household updated");
          this.processing = false;
        },
        error => {
          this.processing = false;
        },
        () => {
          this.router.navigate(['households/edit/' + this.householdId]);
        }
      );
    }
  }

  getFormValues() {
    this.household.id = this.householdId;
    this.household.contactName = this.householdForm.get('contactName').value;
    this.household.contactEmail = this.householdForm.get('contactEmail').value;
    this.household.contactPhone = this.householdForm.get('contactPhone').value;
    this.household.contactCellPhone = this.householdForm.get('contactCellPhone').value;
    this.household.address1 = this.householdForm.get('address1').value;
    this.household.address2 = this.householdForm.get('address2').value;
    this.household.city = this.householdForm.get('city').value;
    this.household.state = this.householdForm.get('state').value;
    this.household.zip = this.householdForm.get('zip').value;
    this.household.mailingAddress = this.householdForm.get('mailingAddress').value;
    this.household.mailingCity = this.householdForm.get('mailingCity').value;
    this.household.mailingState = this.householdForm.get('mailingState').value;
    this.household.mailingZip = this.householdForm.get('mailingZip').value;
    this.household.preferredContactMethod = this.householdForm.get('preferredContactMethod').value;
    this.household.addressUnitNumber = this.householdForm.get('addressUnitNumber').value;
    this.household.county = this.householdForm.get('county').value;
    this.household.personsInHousehold = +this.householdForm.get('personsInHousehold').value;
    this.household.pregnancyInHousehold = this.householdForm.get('pregnancyInHousehold').value == true;
    this.household.comments = this.householdForm.get('comments').value;
    this.household.waterTreamentProvided = this.householdForm.get('waterTreamentProvided').value == true;
    this.household.bottledWaterProvided = this.householdForm.get('bottledWaterProvided').value == true;
    this.household.infantsUnder1 = +this.householdForm.get('infantsUnder1').value;
    this.household.infantsUnder2 = +this.householdForm.get('infantsUnder2').value;
    this.household.age1to4 = +this.householdForm.get('age1to4').value;
    this.household.age5to9 = +this.householdForm.get('age5to9').value;
    this.household.age10to14 = +this.householdForm.get('age10to14').value;
    this.household.age15to19 = +this.householdForm.get('age15to19').value;
    this.household.age20to29 = +this.householdForm.get('age20to29').value;
    this.household.age30to39 = +this.householdForm.get('age30to39').value;
    this.household.age40to49 = +this.householdForm.get('age40to49').value;
    this.household.age50to59 = +this.householdForm.get('age50to59').value;
    this.household.age60to69 = +this.householdForm.get('age60to69').value;
    this.household.age70to79 = +this.householdForm.get('age70to79').value;
    this.household.age80Plus = +this.householdForm.get('age80Plus').value;
    this.household.infantsInHousehold = this.householdForm.get('infantsInHousehold').value == true;
    this.household.age15AndBelow = +this.householdForm.get('age15AndBelow').value;
    this.household.age16AndAbove = +this.householdForm.get('age16AndAbove').value;
    this.household.translationNeeded = this.householdForm.get('translationNeeded').value == true;
    this.household.language = this.householdForm.get('language').value;
    this.household.latitude = this.householdForm.get('latitude').value == 0 ? 0 : this.householdForm.get('latitude').value;
    this.household.longitude = this.householdForm.get('longitude').value == 0 ? 0 : this.householdForm.get('longitude').value;
    this.household.requestedConfidentiality = this.householdForm.get('requestedConfidentiality').value == true;
    this.household.learnedOfTesting = this.householdForm.get('learnedOfTesting').value;
    this.household.householdRelyOnWell = this.householdForm.get('householdRelyOnWell').value;
    this.household.countyTestedWell = this.householdForm.get('countyTestedWell').value == true;
    this.household.sharedWell = this.householdForm.get('sharedWell').value == true;
    this.household.nitrateStripResult = this.householdForm.get('nitrateStripResult').value;
    this.household.eligible = this.householdForm.get('eligible').value == true;
    this.household.modifiedBy = this.authService.username;
    this.household.declinedLubgwmaTestingServices = this.householdForm.get('declinedLubgwmaTestingServices').value == true;
    this.household.declinedLubgwmaTreatmentServices = this.householdForm.get('declinedLubgwmaTreatmentServices').value == true;
    this.household.typeOfDecline = this.householdForm.get('typeOfDecline').value;
    this.household.dateOfFurtherOutreach = this.householdForm.get('dateOfFurtherOutreach').value ? formatDate(this.householdForm.get('dateOfFurtherOutreach').value, 'MM/dd/yyyy', 'en-US') : null;
    this.household.dateOfDecline = this.householdForm.get('dateOfDecline').value ? formatDate(this.householdForm.get('dateOfDecline').value, 'MM/dd/yyyy', 'en-US') : null;
    this.household.treatmentTypeOfDecline = this.householdForm.get('treatmentTypeOfDecline').value;
    this.household.treatmentDateOfFurtherOutreach = this.householdForm.get('treatmentDateOfFurtherOutreach').value ? formatDate(this.householdForm.get('treatmentDateOfFurtherOutreach').value, 'MM/dd/yyyy', 'en-US') : null;
    this.household.treatmentDateOfDecline = this.householdForm.get('treatmentDateOfDecline').value ? formatDate(this.householdForm.get('treatmentDateOfDecline').value, 'MM/dd/yyyy', 'en-US') : null;

    if (this.householdForm.get('residence').value == 'Rent') {
      this.household.renter = true;
      this.household.owner = false;
      this.household.residenceOther = '';
      this.household.residence = 'Rent';
    }
    else if (this.householdForm.get('residence').value == 'Own') {
      this.household.renter = false;
      this.household.owner = true;
      this.household.residenceOther = '';
      this.household.residence = 'Own';
    }
    else {
      this.household.renter = false;
      this.household.owner = false;
      this.household.residenceOther = this.householdForm.get('residenceOther').value;
      this.household.residence = 'Other';
    }
  }

  getAddress() {
    var values = [];
    values.push(this.household.address1);
    values.push(this.household.address2);
    values.push(this.household.city);
    values.push(this.household.state);
    values.push(this.household.zip);
    return values.filter(x => x).join(', ');
  }

  setFormValues() {
    this.address = this.getAddress();
    this.household.id = this.householdId;
    this.householdForm.get('contactName').setValue(this.household.contactName);
    this.householdForm.get('contactEmail').setValue(this.household.contactEmail);
    this.householdForm.get('contactPhone').setValue(this.household.contactPhone);
    this.householdForm.get('contactCellPhone').setValue(this.household.contactCellPhone)
    this.householdForm.get('addressUnitNumber').setValue(this.household.addressUnitNumber);
    this.householdForm.get('address1').setValue(this.household.address1);
    this.householdForm.get('address2').setValue(this.household.address2);
    this.householdForm.get('city').setValue(this.household.city);
    this.householdForm.get('state').setValue(this.household.state);
    this.householdForm.get('zip').setValue(this.household.zip);
    this.householdForm.get('county').setValue(this.household.county);
    this.householdForm.get('personsInHousehold').setValue(this.household.personsInHousehold);
    this.householdForm.get('pregnancyInHousehold').setValue(this.household.pregnancyInHousehold);
    this.householdForm.get('comments').setValue(this.household.comments);
    this.householdForm.get('waterTreamentProvided').setValue(this.household.waterTreamentProvided);
    this.householdForm.get('bottledWaterProvided').setValue(this.household.bottledWaterProvided);
    this.householdForm.get('infantsUnder1').setValue(this.household.infantsUnder1);
    this.householdForm.get('age1to4').setValue(this.household.age1to4);
    this.householdForm.get('age5to9').setValue(this.household.age5to9);
    this.householdForm.get('age10to14').setValue(this.household.age10to14);
    this.householdForm.get('age15to19').setValue(this.household.age15to19);
    this.householdForm.get('age20to29').setValue(this.household.age20to29);
    this.householdForm.get('age30to39').setValue(this.household.age30to39);
    this.householdForm.get('age40to49').setValue(this.household.age40to49);
    this.householdForm.get('age50to59').setValue(this.household.age50to59);
    this.householdForm.get('age60to69').setValue(this.household.age60to69);
    this.householdForm.get('age70to79').setValue(this.household.age70to79);
    this.householdForm.get('age80Plus').setValue(this.household.age80Plus);
    this.householdForm.get('infantsInHousehold').setValue(this.household.infantsInHousehold);
    this.householdForm.get('age15AndBelow').setValue(this.household.age15AndBelow);
    this.householdForm.get('age16AndAbove').setValue(this.household.age16AndAbove);
    this.householdForm.get('mailingAddress').setValue(this.household.mailingAddress);
    this.householdForm.get('mailingCity').setValue(this.household.mailingCity);
    this.householdForm.get('mailingState').setValue(this.household.mailingState);
    this.householdForm.get('mailingZip').setValue(this.household.mailingZip);
    this.householdForm.get('preferredContactMethod').setValue(this.household.preferredContactMethod);
    this.householdForm.get('infantsUnder2').setValue(this.household.infantsUnder2);
    this.householdForm.get('translationNeeded').setValue(this.household.translationNeeded);
    this.householdForm.get('language').setValue(this.household.language);
    this.householdForm.get('latitude').setValue(this.household.latitude);
    this.householdForm.get('longitude').setValue(this.household.longitude);
    this.householdForm.get('requestedConfidentiality').setValue(this.household.requestedConfidentiality);
    this.householdForm.get('learnedOfTesting').setValue(this.household.learnedOfTesting);
    this.householdForm.get('householdRelyOnWell').setValue(this.household.householdRelyOnWell);
    this.householdForm.get('requestedConfidentiality').setValue(this.household.requestedConfidentiality);
    this.householdForm.get('countyTestedWell').setValue(this.household.countyTestedWell);
    this.householdForm.get('sharedWell').setValue(this.household.sharedWell);
    this.householdForm.get('nitrateStripResult').setValue(this.household.nitrateStripResult);
    this.householdForm.get('eligible').setValue(this.household.eligible);
    this.householdForm.get('declinedLubgwmaTestingServices').setValue(this.household.declinedLubgwmaTestingServices);
    this.householdForm.get('declinedLubgwmaTreatmentServices').setValue(this.household.declinedLubgwmaTreatmentServices);
    this.householdForm.get('residence').setValue(this.household.residence);
    this.householdForm.get('residenceOther').setValue(this.household.residenceOther);
    this.householdForm.get('dateOfDecline').setValue(this.household.dateOfDecline ? new Date(this.household.dateOfDecline).toISOString() : null);
    this.householdForm.get('dateOfFurtherOutreach').setValue(this.household.dateOfFurtherOutreach ? new Date(this.household.dateOfFurtherOutreach).toISOString() : null);
    this.householdForm.get('typeOfDecline').setValue(this.household.typeOfDecline);
    this.householdForm.get('treatmentDateOfDecline').setValue(this.household.treatmentDateOfDecline ? new Date(this.household.treatmentDateOfDecline).toISOString() : null);
    this.householdForm.get('treatmentDateOfFurtherOutreach').setValue(this.household.treatmentDateOfFurtherOutreach ? new Date(this.household.treatmentDateOfFurtherOutreach).toISOString() : null);
    this.householdForm.get('treatmentTypeOfDecline').setValue(this.household.treatmentTypeOfDecline);
  }
}